
















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class WraLoader extends Vue {
  @Prop({ default: false }) public isColored!: boolean;
  @Prop({ default: false }) public isOnDark!: boolean;
  @Prop({ default: false }) public isSmall!: boolean;
}
